import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import jwtDecode from 'jwt-decode'
import Raven from 'raven-js'
import ReactGA from 'react-ga'
import { authenticate as auth } from '../api/Authenticate'
import getLayersFromJwt from '../utility/getLayersFromJwt'

// Redux type and action creators
const { Types, Creators } = createActions({
  authenticate: [],
  layers: [],
  loginRequested: [],
  loginFulfilled: ['accessToken', 'idToken', 'expiresAt'],
  loginFailed: ['error'],
  loginFetching: [],
  loginDialogOpen: [],
  loginDialogClose: [],
  loginDialogToggle: [],
  logout: []
})

export const LoginTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  fetching: false,
  authenticated: false,
  loginDialogOpen: false,
  accessToken: null,
  idToken: null,
  expiresAt: null,
  roles: {},
  layers: [],
  error: null
})

// Redux reducers
export const authenticate = state => {
  const { idToken, roles } = state
  const authenticated = auth.isAuthenticated()

  if (roles.name) {
    ReactGA.set({ email: roles.name })
  }
  return state.merge({ authenticated, idToken })
}

export const loginRequested = state => {
  return state.merge({ fetching: true })
}

export const loginFulfilled = (state, { accessToken, idToken, expiresAt }) => {
  console.log('loginFulfilled')
  const jwt = jwtDecode(idToken)
  Raven.setUserContext({
    jwt
  })
  const layers = getLayersFromJwt(jwt)
  return state.merge({
    authenticated: false,
    fetching: false,
    accessToken,
    idToken,
    expiresAt,
    roles: jwt,
    layers,
    error: null
  })
}

export const loginFailed = (state, action) => {
  const { error } = action
  console.log('redux')
  console.log(action)
  console.log(error)

  return state.merge({ authenticated: false, fetching: false, error })
}

export const loginFetching = state => {
  return state.merge({ fetching: true })
}

export const loginDialogOpen = (state, action) => {
  return state.merge({ loginDialogOpen: true })
}

export const loginDialogClose = (state, action) => {
  return state.merge({ loginDialogOpen: false })
}

export const loginDialogToggle = (state, action) => {
  const { loginDialogOpen } = state
  return state.merge({ loginDialogOpen: !loginDialogOpen })
}

export const logout = state => {
  auth.logout()
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.AUTHENTICATE]: authenticate,
  [Types.LOGIN_REQUESTED]: loginRequested,
  [Types.LOGIN_FULFILLED]: loginFulfilled,
  [Types.LOGIN_FAILED]: loginFailed,
  [Types.LOGIN_FETCHING]: loginFetching,
  [Types.LOGIN_DIALOG_OPEN]: loginDialogOpen,
  [Types.LOGIN_DIALOG_CLOSE]: loginDialogClose,
  [Types.LOGIN_DIALOG_TOGGLE]: loginDialogToggle,
  [Types.LOGOUT]: logout
})



// WEBPACK FOOTER //
// ./src/redux/loginRedux.js